
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { PsychologistCardData } from './types';

interface PsychologistCardSpecialtiesProps {
  psychologist: PsychologistCardData;
}

const PsychologistCardSpecialties: React.FC<PsychologistCardSpecialtiesProps> = ({ psychologist }) => {
  if (!psychologist.specialties || psychologist.specialties.length === 0) return null;
  
  const displaySpecialties = psychologist.specialties.slice(0, 2);
  const remainingCount = psychologist.specialties.length - 2;

  return (
    <div className="mb-3">
      <h4 className="text-sm font-medium text-gray-700 mb-2">Especialidades</h4>
      <div className="flex flex-wrap gap-1">
        {displaySpecialties.map((specialty, index) => (
          <Badge
            key={index}
            className="bg-blue-500 hover:bg-blue-600 text-white text-xs px-3 py-1"
          >
            {specialty}
          </Badge>
        ))}
        {remainingCount > 0 && (
          <Badge className="bg-blue-500 hover:bg-blue-600 text-white text-xs px-3 py-1">
            +{remainingCount}
          </Badge>
        )}
      </div>
    </div>
  );
};

export default PsychologistCardSpecialties;
